export default __webpack_public_path__ + "static/thanks-img-c90264f310edcd510b99063438ad6dd2.png";